"use strict";
class UdtMotion {
    constructor() {
        this.Version = 0;
        this.DataLength = 0;
        this.MovingState1 = false;
        this.MovingState2 = false;
        this.Executability1 = false;
        this.Executability2 = false;
        this.GroupError = false;
        this.NumberOfFinalPosition = 0;
        this.FinalPosition = []; //0..15
        this.Interlock1 = false;
        this.Interlock2 = false;
        this.ManualInterlock1 = false;
        this.ManualInterlock2 = false;
        this.ManualEnable1 = false;
        this.ManualEnable2 = false;
        this.ManualOperation1 = false;
        this.ManualOperation2 = false;
        this.DisplayOrder = []; //0..15
        this.Trigger1 = false;
        this.Trigger2 = false;
        this.AutomaticTrigger1 = false;
        this.AutomaticTrigger2 = false;
        this.Control1 = false;
        this.Control2 = false;
        this.PositionFlag = []; //0..15
        this.HmiId = 0;
    }
}
exports.UdtMotion = UdtMotion;
